import React from 'react';
import './NavigationTab.scss';

const NavigationTab = ({ activeTab, setActiveTab }) => {
	const navTabs = [
		'Other Details',
		'Address',
		'Contact person',
		'Bank Details',
		'Upload Document',
		'Remarks',
	];

	return (
		<div>
			<ul className="nav mb-4 mt-2">
				{navTabs.map((item, index) => (
					<li
						style={{ cursor: 'pointer' }}
						key={index}
						className="nav-item"
					>
						<a
							style={{ cursor: 'pointer' }}
							className={`nav-link ${activeTab === item ? 'active' : ''} cursur-pointer`}
							onClick={() => setActiveTab(item)}
						>
							{item}
						</a>
					</li>
				))}
			</ul>
		</div>
	);
};

export default NavigationTab;
